import { render, staticRenderFns } from "./DonationPage.vue?vue&type=template&id=09f3547e&scoped=true"
import script from "./DonationPage.vue?vue&type=script&lang=js"
export * from "./DonationPage.vue?vue&type=script&lang=js"
import style0 from "./DonationPage.vue?vue&type=style&index=0&id=09f3547e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f3547e",
  null
  
)

export default component.exports